import React from "react";
import { buildPlayStoreUrl } from "./utm";
import PlayStoreCTA from "./PlayStoreCTA";

const featuresIncluded = [
  "20,000+ video lectures",
  "1,00,000+ practice questions",
  "Kunji AI doubt solving",
  "Previous Year Question papers",
  "Model & class test papers",
  "Daily quizzes + offline mode",
];

const tiers = [
  {
    id: "trial",
    badge: null,
    headline: "7-Day Free Trial",
    headlineHi: "7 दिन Free Trial",
    price: "₹0",
    period: "7 दिन",
    sub: "No credit card. Full app unlocked.",
    cta: "Start Free Trial",
    ctaHi: "Free Trial शुरू करें",
    utmTerm: "tier-trial",
  },
  {
    id: "monthly",
    badge: null,
    headline: "Monthly",
    headlineHi: "1 महीना",
    price: "₹99",
    period: "/ month",
    sub: "Pay-as-you-go, cancel anytime in-app.",
    cta: "Subscribe Monthly",
    ctaHi: "Monthly Subscribe करें",
    utmTerm: "tier-monthly",
  },
  {
    id: "quarterly",
    badge: null,
    headline: "Quarterly",
    headlineHi: "3 महीने",
    price: "₹249",
    period: "/ 90 दिन",
    sub: "~₹83 / month — Monthly से ~₹48 बचाएँ।",
    cta: "Subscribe Quarterly",
    ctaHi: "Quarterly Subscribe करें",
    utmTerm: "tier-quarterly",
  },
  {
    id: "yearly",
    badge: "Most Popular · Save ~₹589",
    headline: "Yearly",
    headlineHi: "1 साल",
    price: "₹599",
    period: "/ year",
    sub: "Equivalent to ₹50 / month — best value.",
    cta: "Subscribe Yearly",
    ctaHi: "Yearly Subscribe करें",
    utmTerm: "tier-yearly",
    highlight: true,
  },
];

const PricingBlock = ({
  medium = "pathyacharya_pricing",
  campaign,
}) => {
  return (
    <section
      id="pricing"
      aria-label="Pricing"
      className="py-14 px-4 bg-gray-50"
    >
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">
            एक छोटा सा खर्च, एक पूरा साल की पढ़ाई
          </h2>
          <p className="mt-2 text-gray-600">
            7 दिन फ्री शुरू करें — पसंद आए तभी subscribe करें।
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {tiers.map((t) => (
            <div
              key={t.id}
              className={`relative rounded-2xl p-6 bg-white border ${
                t.highlight
                  ? "border-blue-600 shadow-xl ring-2 ring-blue-200"
                  : "border-gray-200 shadow-sm"
              }`}
            >
              {t.badge && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-blue-600 text-white text-xs font-semibold px-3 py-1 rounded-full whitespace-nowrap">
                  {t.badge}
                </div>
              )}
              <h3 className="text-lg font-semibold text-gray-700">
                {t.headlineHi}{" "}
                <span className="text-gray-400 font-normal">
                  ({t.headline})
                </span>
              </h3>
              <div className="mt-3 flex items-baseline gap-1">
                <span
                  className={`text-4xl font-extrabold ${
                    t.highlight ? "text-blue-600" : "text-gray-900"
                  }`}
                >
                  {t.price}
                </span>
                <span className="text-gray-500 text-sm">{t.period}</span>
              </div>
              <p className="mt-1 text-sm text-gray-600">{t.sub}</p>
              <a
                href={buildPlayStoreUrl({
                  medium,
                  campaign,
                  term: t.utmTerm,
                })}
                target="_blank"
                rel="noopener noreferrer"
                className={`mt-5 inline-flex w-full justify-center items-center font-semibold rounded-lg py-3 transition-colors ${
                  t.highlight
                    ? "bg-blue-600 hover:bg-blue-700 text-white"
                    : "bg-gray-900 hover:bg-gray-800 text-white"
                }`}
              >
                {t.ctaHi}
              </a>
            </div>
          ))}
        </div>

        <div className="mt-10 max-w-2xl mx-auto bg-white rounded-2xl border border-gray-200 p-6">
          <p className="font-semibold text-gray-900 mb-3">
            हर plan में सबकुछ शामिल है:
          </p>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-y-2 text-sm text-gray-700">
            {featuresIncluded.map((f) => (
              <li key={f} className="flex items-start gap-2">
                <span aria-hidden className="text-blue-600 font-bold">
                  ✓
                </span>
                <span>{f}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-8 flex justify-center">
          <PlayStoreCTA
            href={buildPlayStoreUrl({
              medium,
              campaign,
              term: "play-badge",
            })}
            badgeClassName="h-14 sm:h-16"
            qrSize="w-24 h-24"
          />
        </div>
      </div>
    </section>
  );
};

export default PricingBlock;
